import { combineReducers } from 'redux';
import newSurveyDesignReducer from '../views/new-survey-design/state/newSurveyDesignSlice';

export default combineReducers({
    newSurveyDesign: newSurveyDesignReducer,
});
